import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { FeedbackMetadataResponse } from '../models';
import {
  MandatoryFeedbackDialogComponent,
  MandatoryFeedbackDialogData,
} from '../shared/mandatory-feedback-dialog/mandatory-feedback-dialog.component';

@Injectable({ providedIn: 'root' })
export class MandatoryFeedbackService {
  private readonly dialog = inject(MatDialog);
  private isShowing = false;

  get isDialogOpen(): boolean {
    return this.isShowing;
  }

  async openFeedbackDialog(
    metadata?: FeedbackMetadataResponse | null,
    extraData?: Partial<MandatoryFeedbackDialogData>,
  ): Promise<boolean> {
    if (this.isShowing) {
      return false;
    }

    this.isShowing = true;
    try {
      const dialogRef = this.dialog.open(MandatoryFeedbackDialogComponent, {
        data: { metadata, ...extraData },
        disableClose: true,
        width: '100%',
        maxWidth: '560px',
        panelClass: 'mandatory-feedback-dialog-panel',
      });

      const result = await firstValueFrom(dialogRef.afterClosed());
      return result === true;
    } finally {
      this.isShowing = false;
    }
  }
}
